<main class="seller-guide">
  <section class="seller-guide__hero" aria-labelledby="seller-guide-title">
    <img
      class="seller-guide__hero-image"
      [src]="assetPaths.images.heroes.guidesUltrawide"
      alt=""
      aria-hidden="true">
    <div class="seller-guide__hero-overlay">
      <p class="seller-guide__eyebrow">Gabali Realty · Laredo &amp; South Texas</p>
      <h1 id="seller-guide-title" class="seller-guide__hero-title">Seller's Guide</h1>
      <p class="seller-guide__hero-subtitle">
        From pricing and prep to accepted offer and closing — a straightforward path to selling your home.
      </p>
    </div>
  </section>

  <section class="seller-guide__intro">
    <p class="seller-guide__lede">
      Selling a home means dozens of decisions at once. Gabali Realty breaks the journey into five clear steps
      so you know what to do next — and who is handling each part for you.
    </p>
    <ul class="seller-guide__highlights">
      @for (item of highlights; track item) {
        <li class="seller-guide__highlight">{{ item }}</li>
      }
    </ul>
  </section>

  <section class="seller-guide__steps" aria-labelledby="steps-heading">
    <header class="seller-guide__section-header">
      <h2 id="steps-heading" class="seller-guide__section-title">5 Steps to a Successful Sale</h2>
      <p class="seller-guide__section-intro">
        Tap a step below to see what happens and how your Gabali agent guides you through it.
      </p>
    </header>
    <app-sell-guide-card></app-sell-guide-card>
  </section>

  <section class="seller-guide__prep" aria-labelledby="prep-heading">
    <header class="seller-guide__section-header">
      <h2 id="prep-heading" class="seller-guide__section-title">Before You List</h2>
      <p class="seller-guide__section-intro">
        A little preparation upfront can mean fewer days on market and stronger offers when buyers start touring.
      </p>
    </header>
    <ul class="seller-guide__prep-list">
      @for (item of prepItems; track item.title) {
        <li class="seller-guide__prep-item">
          <span class="seller-guide__prep-title">{{ item.title }}</span>
          <span class="seller-guide__prep-detail">{{ item.detail }}</span>
        </li>
      }
    </ul>
  </section>

  <section class="seller-guide__marketing" aria-labelledby="marketing-heading">
    <header class="seller-guide__section-header">
      <h2 id="marketing-heading" class="seller-guide__section-title">How We Market Your Property</h2>
      <p class="seller-guide__section-intro">
        Gabali agents combine MLS distribution, online search, and local outreach so your listing reaches the widest qualified buyer pool.
      </p>
    </header>
    <div class="seller-guide__marketing-grid">
      @for (benefit of marketingBenefits; track benefit.title) {
        <article class="seller-guide__marketing-card">
          <h3 class="seller-guide__marketing-title">{{ benefit.title }}</h3>
          <p class="seller-guide__marketing-copy">{{ benefit.description }}</p>
        </article>
      }
    </div>
  </section>

  <section class="seller-guide__resources" aria-labelledby="resources-heading">
    <header class="seller-guide__section-header">
      <h2 id="resources-heading" class="seller-guide__section-title">Tools to Get Started</h2>
      <p class="seller-guide__section-intro">
        Explore these resources on your own, then talk with an agent when you are ready to list.
      </p>
    </header>
    <div class="seller-guide__resource-grid">
      @for (resource of resources; track resource.title) {
        <article class="seller-guide__resource-card">
          <h3 class="seller-guide__resource-title">{{ resource.title }}</h3>
          <p class="seller-guide__resource-copy">{{ resource.description }}</p>
          <a class="seller-guide__resource-link" [routerLink]="resource.link">
            {{ resource.linkLabel }}
            <span aria-hidden="true">→</span>
          </a>
        </article>
      }
    </div>
  </section>

  <section class="seller-guide__local" aria-labelledby="local-heading">
    <header class="seller-guide__section-header">
      <h2 id="local-heading" class="seller-guide__section-title">Laredo Seller Tips</h2>
      <p class="seller-guide__section-intro">
        Local market knowledge makes the difference between a listing that lingers and one that closes on your terms.
      </p>
    </header>
    <div class="seller-guide__tips-grid">
      @for (tip of localTips; track tip.title) {
        <article class="seller-guide__tip-card">
          <h3 class="seller-guide__tip-title">{{ tip.title }}</h3>
          <p class="seller-guide__tip-copy">{{ tip.description }}</p>
        </article>
      }
    </div>
  </section>

  <section class="seller-guide__cta" aria-labelledby="cta-heading">
    <h2 id="cta-heading" class="seller-guide__cta-title">Ready to find out what your home could sell for?</h2>
    <p class="seller-guide__cta-copy">
      Talk with a Gabali agent about pricing, timing, and what to do before you list — no obligation.
    </p>
    <div class="seller-guide__cta-actions">
      <a class="seller-guide__cta-btn seller-guide__cta-btn--primary" routerLink="/home-estimate-page">Get an Estimate</a>
      <a class="seller-guide__cta-btn seller-guide__cta-btn--secondary" routerLink="/agents">Meet an Agent</a>
      <a class="seller-guide__cta-btn seller-guide__cta-btn--secondary" routerLink="/contact-page">Contact Us</a>
    </div>
  </section>
</main>
